export default __webpack_public_path__ + "static/media/placeholder_dummy2016-coach02-mobile-de.49d07545.png";